import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
  OnDestroy,
} from "@angular/core";
import { Table, TableModule } from "primeng/table";
import * as FileSaver from "file-saver";
import { ActivatedRoute } from "@angular/router";
import { IpClientDepositDetailValue } from "../../../core/models/invoice-preview/IpClientDepositDetailValue";
import { InvoicePreviewSummaryService } from "../../../core/services/invoice-preview-summary.service";
import { LoaderService } from "../../../core/services/loader.service";
import { CommonModule } from "@angular/common";
import { ButtonModule } from "primeng/button";
import { CardModule } from "primeng/card";
import { InputTextModule } from "primeng/inputtext";

@Component({
  selector: "jni-invoice-preview-client-deposit",
  templateUrl: "./client-deposit.component.html",
  styleUrls: ["./client-deposit.component.scss"],
  imports: [
    CommonModule,
    TableModule,
    ButtonModule,
    CardModule,
    InputTextModule,
  ],
})
export class InvoicePreviewClientDepositComponent implements OnInit, OnDestroy {
  @Input() invoicePreviewNumber = "";
  @Output() scrollHiddenStatus = new EventEmitter();
  @Output() closeModalEvent = new EventEmitter();

  ipClientDepositDetailValue: IpClientDepositDetailValue[] = [];

  @ViewChild("dt") table!: Table;

  constructor(
    private _loaderService: LoaderService,
    public _activatedRoute: ActivatedRoute,
    private _invoicePreviewSummaryService: InvoicePreviewSummaryService
  ) {}

  ngOnInit(): void {
    this.getFreightCharges();
  }

  clearTable(table: Table) {
    table.clear();
  }

  exportExcelFile() {
    this.exportExcelForFilterData(this.ipClientDepositDetailValue);
  }

  exportExcelForFilterData(filterclientlist: IpClientDepositDetailValue[]) {
    const object = filterclientlist.map(datum => {
      return {
        ["Creation Date"]: datum.InvoiceDate,
        ["Amount"]: datum.Amount,
        ["Description"]: datum.Txt,
      };
    });

    import("xlsx").then(xlsx => {
      const worksheet = xlsx.utils.json_to_sheet(object);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer: ArrayBuffer = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
      this.saveAsExcelFile(excelBuffer, "FreightChargeReport");
    });
  }

  saveAsExcelFile(buffer: ArrayBuffer, fileName: string): void {
    const EXCEL_TYPE =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const EXCEL_EXTENSION = ".xlsx";
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE,
    });
    FileSaver.saveAs(
      data,
      fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
    );
  }

  ngOnDestroy(): void {
    this.scrollHiddenStatus.emit();
  }

  getFreightCharges() {
    this._loaderService.setLoaderState(true);
    if (this.invoicePreviewNumber) {
      const oDataFilter = `?$filter=ProposalId eq '${this.invoicePreviewNumber}'`;
      this._invoicePreviewSummaryService
        .getIpClientDeposit(oDataFilter)
        .subscribe({
          next: res => {
            this.ipClientDepositDetailValue = res.data;
            this._loaderService.setLoaderState(false);
          },
          error: () => {
            this._loaderService.setLoaderState(false);
          },
        });
    }
  }

  onCloseModalEvent() {
    this.closeModalEvent.emit();
  }
}
